import useFetch from 'Api/useFetch';

const useModuleTotals = (entity_id, entity_record_id) => {
    const ctx = useFetch(
        '/api/v2/modules/totals',
        {
            entity_id: entity_id,
            entity_record_id: entity_record_id
        },
        {
            staleTime: 1000 * 60
        }
    )

    return {
        ...ctx,
        data: ctx?.data?.data
    };
}

export default useModuleTotals;